import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import FormSF from '../../../widgets/form/FormSF'
import URLUtils from '../../../util/URLUtils'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const OrderCreateUI = ({context, messageList,
  // customerId
  customerId, customerIdList, onCustomerIdChange, customerIdError,
  // order name
  orderName, onOrderNameChange, orderNameError, setOrderNameError,
  // dueDate
  dueDate, onDueDateChange, dueDateError, setDueDateError,
  // expectedMargin
  expectedMargin, onExpectedMarginChange, expectedMarginError, setExpectedMarginError,
  // form
  onSubmit, submitted, successMsg, errorList, errorCode, setErrorList,
  }) =>
  <CardUI context={context}>
    <FormSF context={context} messageList={messageList} buttonMessageKey='c_create'
      onSubmit={onSubmit} busy={submitted}
      successMsg={successMsg} errorList={errorList} errorCode={errorCode} setErrorList={setErrorList}
    >
      <InputSelectUI name='customerId' value={customerId} required={true}
        messageList={messageList} labelKey='c_customer'
        optionList={customerIdList}
        onChange={onCustomerIdChange} error={customerIdError}
      />
      <InputTextSF type='text' name='orderName' required={true} maxLength={40}
        messageList={messageList} labelKey='c_order_name'
        value={orderName} onChange={onOrderNameChange}
        error={orderNameError} setError={setOrderNameError}
        autoFocus={true}
      />
      <InputTextSF type='text' name='expectedMargin' required={true} maxLength={2}
        messageList={messageList} labelKey='c_expected_margin'
        value={expectedMargin} onChange={onExpectedMarginChange}
        error={expectedMarginError} setError={setExpectedMarginError}
        autoFocus={true}
      />
      <InputDateUI context={context} name='dueDate'
        messageList={messageList} labelKey='c_due_date'
        selectedDateISO={dueDate} onChange={onDueDateChange}
        error={dueDateError} setError={setDueDateError}
      />
    </FormSF>
  </CardUI>

export default OrderCreateUI
